var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTip)?_c('div',{staticClass:"toast"},[_vm._v(_vm._s(_vm.toastText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }